import { createCarouselAndChildrenNodes } from '../../functions/utils'

// eslint-disable-next-line
export default async (component, event, ui) => {
  // eslint-disable-next-line
  const carouselNode = createCarouselAndChildrenNodes(event, ui)
}